import {
  isWeb,
  setupReactNative,
  styled,
  useMediaPropsActive
} from "@tamagui/core";
import { Image as RNImage } from "react-native";
setupReactNative({
  Image: RNImage
});
const StyledImage = styled(RNImage, {
  name: "Image",
  position: "relative",
  source: { uri: "" },
  zIndex: 1
});
const Image = StyledImage.extractable((inProps) => {
  const props = useMediaPropsActive(inProps);
  const { src, ...rest } = props;
  const source = typeof src === "string" ? { uri: src, ...isWeb && { width: props.width, height: props.height } } : src;
  return <StyledImage source={source} {...rest} />;
});
export {
  Image
};
//# sourceMappingURL=Image.js.map
